export const ECRON_BACK_URL = process.env.REACT_APP_ECRON_BACK_URL;
export const ECRON_BACK_LOCAL_URL = process.env.REACT_APP_ECRON_BACK_LOCAL_URL;
